import { ProductMenu } from './productMenuTypes';

const defaultState: ProductMenu = {
  filters: {},
  swiper: {
    currentSubFilter: 0,
    currentFilter: '',
  },
};

export default defaultState;
